// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__34YPh","disabled":"FileBtn_disabled__x09w7","warn":"FileBtn_warn__15Yx0","fade":"FileBtn_fade__1JeNu"};